export default () => "saved items";
